import ActionReducer from 'types/ActionReducer';
import ACTIONS from 'constants/actionTypes';

export interface Settings {
  wl: string;
  wlId: number | null;
  htmlDocumentTitle: string;
  htmlDocumentDescription: string;
  gtmId: string;
  supportEmail: string;
  salesEmail: string;
  chargebacksEmail: string;
  isEshopLinkAvailable: boolean;
  isBulkPayoutsExpanded: boolean;
  isSignUpAvailable: boolean;
  lexemeMap: {
    [key: string]: {
      [key: string]: string;
    };
  };
  visibleLegalLink: boolean;
  brandConfig: {
    id: string;
    brandConfigVersion: string;
    config: {
      theme: {
        brand: {
          main: string;
          highlight: string;
          dark: string;
        };
        palette: {
          [key: string]: {
            [key: number]: string;
          };
        };
        fontFamily: {
          [key: string]: {
            heading: string;
            body: string;
          };
        };
        fontStyle: {
          letterSpacing: string;
        };
        color: {
          [key: string]: {
            [key: string]: string;
          };
        };
        component: {
          [key: string]: {
            [key: string]: string;
          };
        };
      };
      assets: {
        logoUrl: string;
        logoLightUrl: string;
        loginPictureUrl: string;
        loginPictureUrlLaptop: string;
        loginPictureUrlTablet: string;
        loginPictureUrlMobile: string;
        faviconUrl: string;
      };
    };
  };
  homePage: {
    bannerConfig: {
      image: string;
      buttonLink: string;
      buttonTitle: string;
      title: string;
      text: string;
    } | null;
  };
  languagesAvailable: { id: string; text: string; countryCode: string }[];
  isNewMenuAvailable: boolean;
}

const initialState: Settings = {
  wl: '',
  wlId: null,
  gtmId: '',
  htmlDocumentTitle: '',
  htmlDocumentDescription: '',
  supportEmail: '',
  salesEmail: '',
  chargebacksEmail: '',
  visibleLegalLink: false,
  isSignUpAvailable: false,
  isEshopLinkAvailable: false,
  isBulkPayoutsExpanded: false,
  lexemeMap: {},
  brandConfig: {
    id: '',
    brandConfigVersion: '',
    config: {
      theme: {
        brand: {
          main: '',
          highlight: '',
          dark: '',
        },
        palette: {},
        fontFamily: {},
        fontStyle: {
          letterSpacing: 'normal',
        },
        color: {},
        component: {},
      },
      assets: {
        logoUrl: '',
        logoLightUrl: '',
        loginPictureUrl: '',
        loginPictureUrlLaptop: '',
        loginPictureUrlTablet: '',
        loginPictureUrlMobile: '',
        faviconUrl: '',
      },
    },
  },
  homePage: {
    bannerConfig: null,
  },
  languagesAvailable: [],
  isNewMenuAvailable: false,
};

export const settings = (state = initialState, action: ActionReducer) => {
  const { type, payload } = action;
  switch (type) {
    case ACTIONS.SET_WL:
      return { ...state, ...payload };
    case ACTIONS.UPDATE_BRAND_CONFIG:
      return {
        ...state,
        brandConfig: {
          ...state.brandConfig,
          ...payload,
        },
      };
    default:
      return state;
  }
};

export default settings;
